/*
 * @Author: wolfsheller
 * @Description: 支付配置管理
 * @Date: 2018-07-19 17:22:26
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-02 11:15:36
 */
const payset = {
  state: {
    channelSet: [],
    channelSetFlag: ''
  },
  mutations: {
    SET_CHANNEL_SET(state, val) {
      state.channelSet = val
    },
    SET_CHANNELSET_FLAG(state, val) {
      state.channelSetFlag = val
    }
  }
}

export default payset


// WEBPACK FOOTER //
// ./src/store/modules/payset.js